'use strict'

import store from './UserConfigStore.js'

import ConfigClass from './js/ConfigClass.js'

class UserConfigModel extends ConfigClass {

  setStore () {
    this.store = store
  }

  setVariables () {
    super.setVariables()
    this.route = {
      getConfigs : 'mod/config/getUserConfigs',
      save : 'mod/config/save',
      pubsubUpdated : 'userconfig:updated',
    }
    this.storePath = 'UserConfig'
    this.configRoom = 'personal'
  }
}

export {
  UserConfigModel,
  UserConfigModel as ConfigModel,
  store
}
export default UserConfigModel
